<template>
  <div class="activity-feed">

      <div class="activity-feed-wrap">

      <div class="activity-feed-single active" v-show="!isLoading">

          <div v-for="review in item.reviews" :key="`review-${review.id}`" :id="`spot-review-row-${review.id}`" class="activity-item review-item">

              <div class="img-wrap">
                  <img :src="review.user.large_profile" :alt="review.user.full_name" v-rjs="2" />
              </div>

              <div class="activity-item-header">
                  <h3>
                      <a :href="`/${review.user.username}`" class="person-hover-trigger" :data-user="review.user.username">
                          {{ review.user.full_name }}
                          <Verified :user="review.user"></Verified>
                      </a>
                      {{ diffForHumans(review.created_at) }}
                  </h3>
              </div>

              <div class="activity-item-meta">
                  <div class="activity-item-rating">
                      <span v-text="review.sentiment"></span>
                      <TraitsList :traits="review.review_traits"></TraitsList>
                  </div>
              </div>

              <ReviewContent :review="review"></ReviewContent>
              <ReviewGallery :review="review"></ReviewGallery>
              <ReviewResponses :review="review"></ReviewResponses>

          </div>

          <p v-if="!item.reviews.length" class="profile-empty-state">
              Be the first to review {{ spot.title }}
          </p>

      </div>

      <div class="activity-feed-single active" v-if="isLoading">
          <Loading v-for="index in 3" :key="`loading-reviews-${index}`" size="large"></Loading>
      </div>

    </div>

  </div>
</template>

<script>

  import Helpers from '@/mixins/Helpers'
  import Loading from '@/components/Loading'
  import Verified from '@/components/Verified'
  import TraitsList from '@/components/Reviews/TraitsList'
  import ReviewContent from './ReviewContent'
  import ReviewGallery from './ReviewGallery'
  import ReviewResponses from './ReviewResponses'

  export default {

      props: ['paginator', 'item', 'currentTab', 'isLoading', 'spot'],

      mixins: [Helpers],

      components: {
          Loading,
          Verified,
          TraitsList,
          ReviewContent,
          ReviewGallery,
          ReviewResponses
      },
  }
</script>
